import React, { forwardRef } from 'react';
import VideoProvider from './contexts/VideoContext';
import SystemProvider from './contexts/SystemContext';
import UploadProvider from './contexts/UploadContext';
import Dashboard from './components/Dashboard';
import PatchEvent, { set, unset } from '@sanity/form-builder/PatchEvent';
import { Box, Portal, ThemeProvider, ToastProvider, studioTheme } from '@sanity/ui';
var VimeoBrowser = forwardRef(function (props, ref) {
    var onFocus = props.onFocus, onChange = props.onChange, tool = props.tool;
    var handleStopPropagation = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
    };
    var onSelect = function (asset) {
        var event = {
            _type: 'vimeo.video',
            _key: Math.random().toString(16).substring(3),
            asset: {
                _ref: asset.resource_key,
                _type: "reference"
            }
        };
        onChange(PatchEvent.from(asset ? set(event) : unset()));
    };
    return React.createElement(SystemProvider, { onFocus: onFocus, onSelect: onSelect, tool: tool },
        React.createElement(VideoProvider, null,
            React.createElement(UploadProvider, null,
                React.createElement(ThemeProvider, { scheme: "dark", theme: studioTheme },
                    React.createElement(ToastProvider, { zOffset: 60000 }, tool ?
                        React.createElement(Box, { ref: ref, className: "h-full relative" },
                            React.createElement(Dashboard, null))
                        : React.createElement(Portal, null,
                            React.createElement(Box, { onDragEnter: handleStopPropagation, onDragLeave: handleStopPropagation, onDragOver: handleStopPropagation, onDrop: handleStopPropagation, onMouseUp: handleStopPropagation, ref: ref, className: "h-auto left-0 fixed top-0 w-full z-800000" },
                                React.createElement(Dashboard, null))))))));
});
export default VimeoBrowser;
